import { PictureDesktopNames } from './picture-enums';
import { PictureTransformations } from './picture-types';

export const mediaLargeDesktopX2 = `
  only screen and (-webkit-min-device-pixel-ratio: 2) and (min-width: 1200px),
  only screen and (   min--moz-device-pixel-ratio: 2) and (min-width: 1200px),
  only screen and (   -o-min-device-pixel-ratio: 2/1) and (min-width: 1200px),
  only screen and (        min-device-pixel-ratio: 2) and (min-width: 1200px),
  only screen and (           min-resolution: 192dpi) and (min-width: 1200px),
  only screen and (            min-resolution: 2dppx) and (min-width: 1200px)
`;

export const mediaLargeDesktop = 'only screen and (min-width: 1200px)';

export const mediaDesktopX2 = `
  only screen and (-webkit-min-device-pixel-ratio: 2) and (min-width: 1024px),
  only screen and (   min--moz-device-pixel-ratio: 2) and (min-width: 1024px),
  only screen and (   -o-min-device-pixel-ratio: 2/1) and (min-width: 1024px),
  only screen and (        min-device-pixel-ratio: 2) and (min-width: 1024px),
  only screen and (           min-resolution: 192dpi) and (min-width: 1024px),
  only screen and (            min-resolution: 2dppx) and (min-width: 1024px)
`;

export const mediaDesktop = 'only screen and (min-width: 1024px)';

export const mediaMoreThenMobileX2 = `
  only screen and (-webkit-min-device-pixel-ratio: 2) and (min-width: 768px),
  only screen and (   min--moz-device-pixel-ratio: 2) and (min-width: 768px),
  only screen and (   -o-min-device-pixel-ratio: 2/1) and (min-width: 768px),
  only screen and (        min-device-pixel-ratio: 2) and (min-width: 768px),
  only screen and (           min-resolution: 192dpi) and (min-width: 768px),
  only screen and (            min-resolution: 2dppx) and (min-width: 768px)
`;

export const mediaMoreThenMobile = 'only screen and (min-width: 768px)';

export const mediaMobileX2 = `
  only screen and (-webkit-min-device-pixel-ratio: 2) and (max-width: 767px),
  only screen and (   min--moz-device-pixel-ratio: 2) and (max-width: 767px),
  only screen and (   -o-min-device-pixel-ratio: 2/1) and (max-width: 767px),
  only screen and (        min-device-pixel-ratio: 2) and (max-width: 767px),
  only screen and (           min-resolution: 192dpi) and (max-width: 767px),
  only screen and (            min-resolution: 2dppx) and (max-width: 767px)
`;

export const mediaMobile = 'only screen and (max-width: 767px)';

export const DEFAULT_IMAGE_TRANSFORMATIONS: PictureTransformations = {
  [PictureDesktopNames.ImgLargeDesk]: {
    width: 578,
    height: 380,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgDesk]: {
    width: 458,
    height: 380,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgTablet]: {
    width: 660,
    height: 380,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgMobile]: {
    width: 288,
    height: 216,
    objectFit: 'fill',
    dpr: '2.0',
  },
};

export const DEFAULT_IMAGE_TWO_COLUMNS_TRANSFORMATIONS: PictureTransformations = {
  ...DEFAULT_IMAGE_TRANSFORMATIONS,
  [PictureDesktopNames.ImgTablet]: {
    ...DEFAULT_IMAGE_TRANSFORMATIONS.imgTablet,
    width: 318,
    height: 216,
  },
};

export const DEFAULT_BIG_IMAGE_TRANSFORMATIONS: PictureTransformations = {
  [PictureDesktopNames.ImgLargeDesk]: {
    width: 578,
    height: 784,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgDesk]: {
    width: 458,
    height: 784,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgTablet]: {
    width: 660,
    height: 456,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgMobile]: {
    width: 288,
    height: 376,
    objectFit: 'fill',
    dpr: '2.0',
  },
};

export const DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS: PictureTransformations = {
  ...DEFAULT_BIG_IMAGE_TRANSFORMATIONS,
  [PictureDesktopNames.ImgTablet]: {
    ...DEFAULT_BIG_IMAGE_TRANSFORMATIONS.imgTablet,
    width: 318,
  },
};
